import Loader from '../../CommonElements/Loader';
import Taptop from '../../CommonElements/TapTop';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';
import React, { Fragment } from 'react';
import ThemeCustomize from '../../CommonElements/ThemeCustomizer';
import { ToastContainer } from 'react-toastify';
import { useContext } from 'react';
import CheckContext from '../../_helper/Customizer';
import { Outlet, useLocation } from 'react-router-dom';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import AnimationThemeContext from '../../_helper/AnimationTheme';
import ConfigDB from '../../Config/ThemeConfig';


const AppLayout = ({ children,
  classNames,
  ...rest }) => {
  const { sidebar_types, settings } = useContext(CheckContext);
  const settings1 = localStorage.getItem('sidebar_Settings') || settings;

  // Force the admin dashboard to use the vertical left sidebar layout.
  // This prevents a saved "horizontal-wrapper" setting from hiding the left menu on the .ca site.
  const savedSidebarType = localStorage.getItem('sidebar_types') || sidebar_types;
  const sidebar_types1 = savedSidebarType && savedSidebarType.includes('horizontal-wrapper')
    ? 'compact-wrapper'
    : (savedSidebarType || 'compact-wrapper');
  const location = useLocation();
  const { animation } = useContext(AnimationThemeContext);
  const animationTheme =
    localStorage.getItem('animation') ||
    animation || ConfigDB.data.router_animation;

  return (
    <Fragment>
      <Loader />
      <Taptop />
      <div className={`page-wrapper ${sidebar_types1} ${settings1}`} id="pageWrapper">
        <Header />
        <div className="page-body-wrapper">
          <Sidebar />
          <div className="page-body admin-page-body">
            <TransitionGroup {...rest}>
              <CSSTransition
                key={location.key}
                timeout={100}
                classNames={animationTheme}
                unmountOnExit
              >
                <Outlet />
              </CSSTransition>
            </TransitionGroup>
          </div>
          <Footer />
        </div>
      </div>
      <ThemeCustomize />
      <ToastContainer />
    </Fragment>
  );
};
export default AppLayout;